const ASSETS_URL = 'https://content.moneydesktop.com/storage/MD_Assets/md/help'

export const HELP_IMAGES = {
  ACCOUNT_DETAILS: `${ASSETS_URL}/account/AccountDetails.png`,
  ACCOUNT_OVERVIEW: `${ASSETS_URL}/account/AccountsOverview.png`,
  ACCOUNT_ADD: `${ASSETS_URL}/account/AddAccount.png`,
  ACCOUNT_BROKEN_CONNECTION: `${ASSETS_URL}/account/BrokenConnection.png`,
  ACCOUNT_HIDE: `${ASSETS_URL}/account/AccountHide.png`,
  ACCOUNT_MANAGE_CONNECTIONS: `${ASSETS_URL}/account/ManageConnections.png`,
  BUDGETS_ADD_SUB_BUDGET: `${ASSETS_URL}/budgets/AddSubBudget.png`,
  BUDGETS_WIDGET: `${ASSETS_URL}/budgets/BudgetWidget.png`,
  BUDGETS_EDIT_INCOME: `${ASSETS_URL}/budgets/EditIncome.png`,
  CASHFLOW_WIDGET: `${ASSETS_URL}/cashflow/CashFlowWidget.png`,
  CASHFLOW_EXPENSE_DETAILS: `${ASSETS_URL}/cashflow/ExpenseDetailsCurrent.png`,
  CASHFLOW_MANAGE_EXPENSES: `${ASSETS_URL}/cashflow/ManageExpenses.png`,
  DEBTS_DETAILS: `${ASSETS_URL}/debts/DebtDetails.png`,
  DEBTS_OVERVIEW: `${ASSETS_URL}/debts/DebtOverview.png`,
  DEBTS_PRIORITIZATION: `${ASSETS_URL}/debts/DebtPrioritization.png`,
  DEBTS_SNOWBALL_METHOD: `${ASSETS_URL}/debts/SnowballMethod.png`,
  GENERAL_CATEGORIZE_TRANSACTIONS: `${ASSETS_URL}/general/CategorizeTransactions.png`,
  GOALS_CREATE_GOAL: `${ASSETS_URL}/goals/CreateGoal.png`,
  GOALS_DEBT_GOALS: `${ASSETS_URL}/goals/DebtGoals.png`,
  GOALS_WIDGET_OVERVIEW: `${ASSETS_URL}/goals/GoalsWidgetOverview.png`,
  GOALS_MANAGE_GOALS: `${ASSETS_URL}/goals/ManageGoals.png`,
  GOALS_RETIREMENT_GOALS: `${ASSETS_URL}/goals/RetirementGoals.png`,
  GOALS_SAVINGS_GOALS: `${ASSETS_URL}/goals/SavingsGoals.png`,
  INSIGHTS_CAROUSEL: `${ASSETS_URL}/insights/InsightsCarousel.png`,
  INSIGHTS_FEED: `${ASSETS_URL}/insights/InsightsFeed.png`,
  INVESTMENTS_WIDGET_DETAILS: `${ASSETS_URL}/investments/WidgetDetails.png`,
  MOBILE_ADD_MOBILE_DEVICE: `${ASSETS_URL}/mobile/AddMobileDevice.png`,
  NETWORTH_ASSETS_LIABILITIES: `${ASSETS_URL}/networth/AssetsLiabilities.png`,
  NETWORTH_GAINS_LOSSES: `${ASSETS_URL}/networth/GainsLosses.png`,
  NETWORTH_WIDGET: `${ASSETS_URL}/networth/NetWorthWidget.png`,
  NOTIFICATIONS_MANAGING: `${ASSETS_URL}/notifications/ManagingNotifications.png`,
  NOTIFICATIONS_OVERVIEW: `${ASSETS_URL}/notifications/NotificationOverview.png`,
  RECURRING_TRANSACTIONS_EXPENSE_DETAILS: `${ASSETS_URL}/recurringtransactions/expenseDetails.png`,
  RECURRING_TRANSACTIONS_MANAGE_EXPENSES: `${ASSETS_URL}/recurringtransactions/manageExpenses.png`,
  RECURRING_TRANSACTIONS_OVERVIEW: `${ASSETS_URL}/recurringtransactions/overview.png`,
  SPENDING_WIDGET: `${ASSETS_URL}/spending/SpendingWidget.png`,
  TRANSACTIONS_CATEGORIZE: `${ASSETS_URL}/transactions/CategorizeTransactions.png`,
  TRANSACTIONS_EDIT: `${ASSETS_URL}/transactions/EditTransactions.png`,
  TRANSACTIONS_EXPORT: `${ASSETS_URL}/transactions/ExportTransactions.png`,
  TRANSACTIONS_OVERVIEW: `${ASSETS_URL}/transactions/Overview.png`,
  TRANSACTIONS_RULES: `${ASSETS_URL}/transactions/TransactionRules.png`,
  TRENDS_WIDGET: `${ASSETS_URL}/trends/TrendsWidget2.png`,
}
